/**
 * Contest API Contract
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateContestInputSchema, UpdateContestInputSchema, ApproveWinnersInputSchema, ContestResponseSchema, ListContestsResponseSchema, ListContestsQuerySchema, AuditLogQuerySchema, AuditLogPageSchema, LeaderboardResponseSchema, ContestScoresResponseSchema, CreateNotificationPlanInputSchema, UpdateNotificationPlanInputSchema, NotificationPlanResponseSchema, ContestDashboardResponseSchema, ScoreTrendInputSchema, ScoreTrendResponseSchema, } from "@hourly/api/contest";
const listContests = oc
    .route({ method: "GET", path: "/contests", summary: "List contests", tags: ["Contests"] })
    .input(ListContestsQuerySchema)
    .output(ListContestsResponseSchema);
const createContest = oc
    .route({ method: "POST", path: "/contests", summary: "Create a contest", tags: ["Contests"], successStatus: 201 })
    .input(CreateContestInputSchema)
    .output(ContestResponseSchema);
const getContest = oc
    .route({ method: "GET", path: "/contests/{id}", summary: "Get a contest by ID", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }))
    .output(ContestResponseSchema);
const updateContest = oc
    .route({ method: "PATCH", path: "/contests/{id}", summary: "Update a contest", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }).merge(UpdateContestInputSchema))
    .output(ContestResponseSchema);
const deleteContest = oc
    .route({ method: "DELETE", path: "/contests/{id}", summary: "Delete a contest", tags: ["Contests"], successStatus: 204 })
    .input(z.object({ id: z.uuid() }))
    .output(z.void());
const approveWinners = oc
    .route({ method: "POST", path: "/contests/{id}/approve-winners", summary: "Approve winners", tags: ["Contests"] })
    .input(ApproveWinnersInputSchema)
    .output(ContestResponseSchema);
const getAuditLog = oc
    .route({ method: "GET", path: "/contests/{id}/audit-log", summary: "Get contest audit log", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }).merge(AuditLogQuerySchema))
    .output(AuditLogPageSchema);
const startContest = oc
    .route({ method: "POST", path: "/contests/{id}/start", summary: "Start a contest (CREATED → IN_PROCESS)", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }))
    .output(ContestResponseSchema);
const endContest = oc
    .route({ method: "POST", path: "/contests/{id}/end", summary: "End a contest early (IN_PROCESS → COMPLETED or TERMINATED)", tags: ["Contests"] })
    .input(z.object({ id: z.uuid(), selectWinner: z.boolean() }))
    .output(ContestResponseSchema);
const archiveContest = oc
    .route({ method: "POST", path: "/contests/{id}/archive", summary: "Archive a completed contest (COMPLETED → ARCHIVED)", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }))
    .output(ContestResponseSchema);
const getLeaderboard = oc
    .route({ method: "GET", path: "/contests/{id}/leaderboard", summary: "Get contest leaderboard", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }))
    .output(LeaderboardResponseSchema);
const getScores = oc
    .route({ method: "GET", path: "/contests/{id}/scores", summary: "Get all scores for a contest", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }))
    .output(ContestScoresResponseSchema);
const getDashboard = oc
    .route({ method: "GET", path: "/contests/dashboard", summary: "Get employee's active contest dashboard cards", tags: ["Contests"] })
    .input(z.object({}))
    .output(ContestDashboardResponseSchema);
const createNotificationPlan = oc
    .route({ method: "POST", path: "/contests/{id}/notifications", summary: "Create a notification plan", tags: ["Contests"], successStatus: 201 })
    .input(z.object({ id: z.uuid() }).merge(CreateNotificationPlanInputSchema))
    .output(NotificationPlanResponseSchema);
const listNotificationPlans = oc
    .route({ method: "GET", path: "/contests/{id}/notifications", summary: "List notification plans for a contest", tags: ["Contests"] })
    .input(z.object({ id: z.uuid() }))
    .output(z.array(NotificationPlanResponseSchema));
const updateNotificationPlan = oc
    .route({ method: "PATCH", path: "/contests/{id}/notifications/{nid}", summary: "Update a notification plan", tags: ["Contests"] })
    .input(z.object({ id: z.uuid(), nid: z.uuid() }).merge(UpdateNotificationPlanInputSchema))
    .output(NotificationPlanResponseSchema);
const deleteNotificationPlan = oc
    .route({ method: "DELETE", path: "/contests/{id}/notifications/{nid}", summary: "Delete a notification plan", tags: ["Contests"], successStatus: 204 })
    .input(z.object({ id: z.uuid(), nid: z.uuid() }))
    .output(z.void());
const getScoreTrend = oc
    .route({ method: "GET", path: "/contests/{contestId}/score-trend", summary: "Get time-series score trend data", tags: ["Contests"] })
    .input(ScoreTrendInputSchema)
    .output(ScoreTrendResponseSchema);
export const contestContract = {
    list: listContests,
    create: createContest,
    getDashboard,
    get: getContest,
    update: updateContest,
    delete: deleteContest,
    approveWinners,
    getAuditLog,
    start: startContest,
    end: endContest,
    archive: archiveContest,
    getLeaderboard,
    getScores,
    createNotificationPlan,
    listNotificationPlans,
    updateNotificationPlan,
    deleteNotificationPlan,
    getScoreTrend,
};
//# sourceMappingURL=contest.js.map